export default {
  importedFiles: {
    uploadModal: {
      button: 'Import',
      title: 'Import Jobs from CSV',
      mixedTitle: 'Import 1099 Jobs from CSV',
      toasts: {
        success: 'Your CSV file import is in progress. You’ll be notified when it’s complete.'
      }
    },
    table: {
      headers: {
        fileName: 'File Name',
        importedTime: 'Imported Time',
        numberOfJobs: 'Number of Jobs',
      },
      noFilesHeader: 'No files found'
    },
    confirmation: {
      delete: {
        title: 'Delete File',
        content: 'Are you sure you want to delete "%fileName%" from the system?'
      }
    },
    errorsModal: {
      header: 'Import Errors',
      content: 'The file cannot be imported. Please import the file again after fixing the following errors:'
    }
  },
  importedDrafts: {
    header: {
      buttons: {
        export: {
          title: 'Export CSV'
        },
        post: {
          title: 'Post Jobs',
          content: {
            postAllJobs: 'Post all jobs',
            postSelectedJobs: 'Post selected jobs',
          },
        },
      },
    },
    filters: {
      dateRange: {
        label: 'Date Range',
      },
      keywords: {
        label: 'Search',
        placeholder: 'Search keywords',
      },
    },
    table: {
      headers: {
        jobName: 'Job Name',
        startDate: 'Start Date',
        startTime: 'Scheduled Start Time',
        scheduledHours: 'Scheduled Hours',
      },
      noResultsHeader: 'No job requests found'
    },
    toasts: {
      pending: 'Your request is processing. You’ll be notified in a few minutes when its complete.',
      error: 'There was a problem submitting your change. Our team has been notified.',
    }
  },
};
